import { SavedAddress } from 'feature/addresses/redux/MyAddresses.api'
import { TSuggest } from 'feature/registration/types'
import { useCallback } from 'react'
import { useFormContext } from 'react-hook-form'
import { useActions } from 'store/hooks'

import { TLastPickedAddress } from '../AddressPopup'
import { FIAS_LEVEL } from 'constants/const'

type TUserHandlers = {
  setViewMode: (str: string) => void
  lastPickedAddress: TLastPickedAddress
}

export const useHandlers = ({
  setViewMode,
  lastPickedAddress,
}: TUserHandlers) => {
  const { trigger, clearErrors, setError } = useFormContext()

  const {
    setErrorMessage: setErrorMessageInState,
    clearInputAddress,
    setSuggests,
    setIsValidAddress,
    setClickMarkCoords,
    setIsError,
    setCenter,
    setInputAddress,
    setInputAddressSuggest,
  } = useActions()

  const selectAddressHandler = (item: TSuggest) => {
    setInputAddressSuggest(item)
    setInputAddress(item.address)
    clearErrors('address')
    if (item.geoLat && item.geoLon) {
      setClickMarkCoords([Number(item.geoLat), Number(item.geoLon)])
      setCenter([Number(item.geoLat), Number(item.geoLon)])
    } else setClickMarkCoords(null)

    if (+item.fiasLevel >= FIAS_LEVEL) {
      setIsValidAddress(true)
    }

    if (+item.fiasLevel > FIAS_LEVEL) {
      trigger('address')
      setViewMode('form')
    }
  }

  const backHandler = () => {
    setCenter(null)
    if (Number(lastPickedAddress.suggest?.fiasLevel) >= FIAS_LEVEL) {
      setInputAddress(lastPickedAddress.value)
      if (lastPickedAddress.suggest)
        setInputAddressSuggest(lastPickedAddress.suggest)
      if (lastPickedAddress.geoLat && lastPickedAddress.geoLon) {
        setClickMarkCoords([lastPickedAddress.geoLat, lastPickedAddress.geoLon])
        setCenter([lastPickedAddress.geoLat, lastPickedAddress.geoLon])
      }
      setIsValidAddress(true)
    } else {
      setClickMarkCoords(null)
      clearInputAddress()
      setIsValidAddress(false)
    }

    setIsError(false)
    setSuggests([])
    setErrorMessageInState('')
    setViewMode('form')
    trigger('address')
  }

  const setErrorAddress = useCallback(
    (type: string, message: string) => {
      setErrorMessageInState(message)
      setIsError(true)
      setError('address', { type, message })
    },
    [setError],
  )

  const userAddressClick = (item: SavedAddress) => {
    setInputAddress(item.address)
    const addressFiasLevel =
      +item.fiasLevel >= FIAS_LEVEL ? item.fiasLevel : FIAS_LEVEL.toString()
    setInputAddressSuggest({ ...item, fiasLevel: addressFiasLevel })
    setClickMarkCoords([Number(item.geoLat), Number(item.geoLon)])
    setCenter([Number(item.geoLat), Number(item.geoLon)])
    if (setViewMode) setViewMode('form')
  }

  return {
    selectAddressHandler,
    backHandler,
    setErrorAddress,
    userAddressClick,
  }
}
